<template lang="pug">
  v-card(color="yellow darken-4" dark hover @click="openList")
    v-card-text(style="height: 128px;")
      v-layout(align-center justify-center column fill-height)
        v-progress-circular(v-if="isLoading" size="70" width="7" color="white" indeterminate)
        animated-number.display-1.font-weight-light(v-if="!isLoading" :value="installationCount" :formatValue="formatToNumber" :duration="1000")
        div.text-xs-center.body-1 {{ $t('labels.installation') }}
</template>

<script>
import dashbaordService from '../../service.js'
import AnimatedNumber from "animated-number-vue";

export default {
  data() {
    return {
      installationCount: 0,
      isLoading: true
    }
  },
  components: {
    AnimatedNumber
  },
  mounted() {
    this.getInstallationCount()
  },
  methods: {
    openList() {
      this.$router.push({name: 'location-dashboard', params: {option: 'installationDone'}});
    },
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getInstallationCount() {
      dashbaordService.installationCount()
      .then(result => {
        this.installationCount = result.data
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
</style>